'use strict';

angular.module('atex.dam').controller('DamFolderExportController', ['$scope',
  function ($scope) {

  $scope.defaultSecParent = "externalid/dam.assets.common.d";
    $scope.$watch('exportOptions.overwriteSecParent', function(newVal) {
      if (!newVal) {
        $scope.exportOptions.securityParent = undefined;
      } else if (newVal && !$scope.exportOptions.securityParent) {
        $scope.exportOptions.securityParent = $scope.defaultSecParent;
      }
    });

    $scope.$watch('exportOptions.removeAssignees', function(newVal) {
      if (!newVal) {
        $scope.exportOptions.newCreatorId = undefined;
      } else if (newVal && !$scope.exportOptions.securityParent) {
        $scope.exportOptions.newCreatorId = '';
      }
    });
  }
]);

